import { makeStyles } from '@rbx/ui';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const colorOfMethod = (method: string, theme: any) => {
  switch (method) {
    case 'get':
      return theme.palette.components.inlineCode.asLink.color;
    case 'put':
      return theme.palette.actionV2.notice.fill;
    case 'post':
      return theme.palette.actionV2.active.fill;
    case 'delete':
      return theme.palette.components.input.outlined.errorBorder;
    case 'options':
      return theme.palette.actionV2.primary.fill;
    case 'head':
      return theme.palette.actionV2.primary.fill;
    case 'patch':
      return theme.palette.actionV2.notice.fill;
    case 'trace':
      return theme.palette.actionV2.primary.fill;
    default:
      return theme.palette.components.inlineCode.asLink.color;
  }
};

// put, options, head, trace not specified
const useColoredMethodStyles = makeStyles()((theme) => ({
  root: {
    display: 'inline-block',
    backgroundColor: theme.palette.media.inlineCodeBackground,
    borderRadius: 4,
    paddingInline: 4,
  },
  get: {
    color: colorOfMethod('get', theme),
  },

  put: {
    color: colorOfMethod('put', theme),
  },

  post: {
    color: colorOfMethod('post', theme),
  },

  del: {
    color: colorOfMethod('del', theme),
  },

  options: {
    color: colorOfMethod('options', theme),
  },

  head: {
    color: colorOfMethod('head', theme),
  },

  patch: {
    color: colorOfMethod('patch', theme),
  },

  trace: {
    color: colorOfMethod('trace', theme),
  },
}));

export default useColoredMethodStyles;
